import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomTopView from "../../Components/CustomTopView";
import LeftSideNav from "../../Components/LeftSideNav";
import TopNavBar from "../../Components/TopNavbar";
import { AppConstants } from "../../Constants/AppConstants";
import { getProductMetalDetailsAPI } from "../../Store/Action/productMetalAction";
import MetalTable from "./Component/MetalTable";
import Colors from "../../theme/Colors";

const ProductMetal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchInputRef = useRef(null);
  const [products, setProducts] = useState([]);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const { userData } = useSelector((state) => state.user);

  const limit = AppConstants.limit;
  const rowsPerPageOptions = [25, 50, 100];
  const rowsPerPageLabel = "Users Per Page";
  
  const [pageNumber, setPageNumber] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState(""); // Added searchQuery state

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/", text: "Masters" },
      { key: "2", href: "/productMetal", text: "Product Metal" },
    ]);
  }, []);

  const [totalCount, setTotalCount] = useState(1);

  const handleChangePage = useCallback((event, newPage) => {
    setPageNumber(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(event.target.value);
    setPageNumber(0);
  }, []);

  const handleSearchChange = useCallback((event) => {
    setSearchQuery(event.target.value);
    setPageNumber(0); // Reset to the first page when search changes
  }, []);

  const onAddProductMetal = useCallback(() => {
    navigate("/AddProductMetal");
  }, [navigate]);

  useEffect(() => {
    const productMetalAPI = async () => {
      try {
        const params = {
          searchQuery: searchQuery || undefined,
          page: pageNumber || undefined,
          limit: limit || undefined,
        };

        dispatch(
          getProductMetalDetailsAPI(params, (result) => {
            setProducts(result?.data || []);
            setTotalCount(result?.totalCount);

            if (searchInputRef.current) {
              searchInputRef.current.focus();
            }
          })
        );
      } catch (error) {
        console.log("Failed to fetch users:", error);
      }
    };
    productMetalAPI();
  }, [dispatch, limit, pageNumber, searchQuery]);

  const recordAfterSorting = products?.slice(
    pageNumber * rowsPerPage,
    (pageNumber + 1) * rowsPerPage
  );

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "20% 80%",
        height: "100vh",
        width: "100vw",
        overflowX: "hidden",
        overflowY: "hidden",
      }}
    >
      <LeftSideNav />

      <div
        style={{
          backgroundColor: Colors.bgColor,
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
       <TopNavBar
          leftSideText={`Hello ${userData?.data?.user_first_name}`}
          isDashboard={true}
        />
         <CustomTopView
          breadcrumbs={breadcrumbs}
          addButtonText={"Add Customer"}
          exportButtonText={"Export Customer"}
          rowsPerPage={rowsPerPage}
          handleRowsPerPageChange={handleChangeRowsPerPage}
          rowPerPageLabel={rowsPerPageLabel}
          onAddButtonClick={onAddProductMetal}
          searchValue={searchQuery}
          onSearchChange={handleSearchChange}
        />

        <MetalTable
          productMetal={recordAfterSorting}
          page={pageNumber}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          totalItems={totalCount}
          rowsPerPageOptions={rowsPerPageOptions}
          searchValue={searchQuery}
          onSearchChange={handleSearchChange}
          rowsPerPageLabel={rowsPerPageLabel}
        />
      </div>
    </div>
  );
};

export default ProductMetal;
